import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { SortDropdown } from "./sortDropdown";
import { Props } from "./type";
import styles from "./styles.scss";

function Toolbar(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolbar}>
      <SortDropdown sortElement={props.sort} setSorter={props.setSort} />
      <div className={styles.filter}>
        <p className={styles.title}>{t("planzoneMembersPage.filters.title")}</p>
        <FilterMenu
          filter={props.filter}
          setFilter={(filter) =>
            props.setFilter({ ...props.filter, ...filter })
          }
          placeholder={t("planzoneMembersPage.filters.default")}
          views={["resources", "groups", "resourceTags"]}
          openedViews={["resources"]}
        />
      </div>
    </div>
  );
}

export { Toolbar };
